// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrpayrollpg-inline-1 {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
}

.hrpayrollpg-inline-2 {
  display: flex;
  gap: 8px;
}

.hrpayrollpg-inline-3 {
  font-size: 12px;
  color: #64748b;
}

.hrpayrollpg-inline-4 {
  display: flex;
  gap: 8px;
}

.hrpayrollpg-inline-5 {
  padding: 0;
  overflow-x: auto;
}

.hrpayrollpg-inline-6 {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
}

.hrpayrollpg-inline-7 {
  font-family: monospace;
  font-size: 11px;
}

.hrpayrollpg-inline-8 {
  display: grid;
  grid-template-columns: 1fr 140px 140px auto;
  gap: 8px;
}

.hrpayrollpg-inline-9 {
  margin-top: 8px;
  font-size: 12px;
  color: #64748b;
}

.hrpayrollpg-inline-10 {
  padding: 0;
  overflow-x: auto;
}

.hrpayrollpg-inline-11 {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
}

.hrpayrollpg-inline-12 {
  font-family: monospace;
  font-size: 11px;
}

.hrpayrollpg-inline-13 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrPayrollPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".hrpayrollpg-inline-1 {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n}\n\n.hrpayrollpg-inline-2 {\n  display: flex;\n  gap: 8px;\n}\n\n.hrpayrollpg-inline-3 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.hrpayrollpg-inline-4 {\n  display: flex;\n  gap: 8px;\n}\n\n.hrpayrollpg-inline-5 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.hrpayrollpg-inline-6 {\n  text-align: center;\n  padding: 20px;\n  color: #94a3b8;\n}\n\n.hrpayrollpg-inline-7 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.hrpayrollpg-inline-8 {\n  display: grid;\n  grid-template-columns: 1fr 140px 140px auto;\n  gap: 8px;\n}\n\n.hrpayrollpg-inline-9 {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.hrpayrollpg-inline-10 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.hrpayrollpg-inline-11 {\n  text-align: center;\n  padding: 20px;\n  color: #94a3b8;\n}\n\n.hrpayrollpg-inline-12 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.hrpayrollpg-inline-13 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
